import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Select, Row, Upload, Radio, Tooltip } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import { useDeepEffect } from '../../../utils/hooks'

const RemarkForm = (props) => {
  const { visible, onOk, onCancel, formData, form, } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        page: formData.page,
        remark: formData.remark,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])


  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          page: values.page,
          remark: values.remark,
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Remark`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Page">
          {getFieldDecorator(`page`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="page"
            placeholder="page" />)}
        </Form.Item>
        <Form.Item label="Remark">
          {getFieldDecorator(`remark`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input.TextArea rows={10}
            name="remark"
            placeholder="remark" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedRemarkForm = Form.create({ name: 'RemarkForm' })(
  RemarkForm
)
export default WrappedRemarkForm
